// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'

Vue.config.productionTip = false

let app = null;
//wait for firebase auth to init before creating the app because it takes some time
/* eslint-disable no-new */
firebase.auth().onAuthStateChanged(()=>{
  //also no need to reinit each time a each user login or out bacause this changes state
  if (!app){
  app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}
})




// WEBPACK FOOTER //
// ./src/main.js